/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Invite_TitleInputs */

const cs_auth_invite_title = /** @type {(inputs: Auth_Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nastavte si heslo`)
};

const en_auth_invite_title = /** @type {(inputs: Auth_Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set your password`)
};

/**
* | output |
* | --- |
* | "Set your password" |
*
* @param {Auth_Invite_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_invite_title = /** @type {((inputs?: Auth_Invite_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Invite_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_invite_title(inputs)
	return cs_auth_invite_title(inputs)
});